import { personFilterLabels } from '@/components/shared/person-filter/labels'

export const assigneeLabels = {
  addAssignees: 'Add assignees',
  searchPlaceholder: personFilterLabels.searchPlaceholder,
  clearAll: 'Clear all',
  unknownUser: 'Unknown User',
  updateErrorTitle: 'Failed to update assignees',
  updateErrorDescription: 'Please try again later.',
} as const
